import { toast } from '@approvalmax/ui/src/components';
import { useCallback, useState } from 'react';
import { useCancelEmailChangeSupportTicket } from 'shared/data/webApp/v2';

import { messages } from './SubsectionEmail.messages';

export const useContactSupportForm = (params: { ticketId?: string }) => {
    const { ticketId } = params;

    const { mutate, isLoading } = useCancelEmailChangeSupportTicket({
        onSuccess: () => {
            toast.success(messages.toastCancelled);
        },
    });

    const [isContactSupportFormVisible, setIsContactSupportFormVisible] = useState(false);
    const [isRequestedPopupVisible, setIsRequestedPopupVisible] = useState(false);

    const handleShowContactSupportForm = useCallback(() => {
        setIsContactSupportFormVisible(true);
    }, []);

    const handleHideContactSupportForm = useCallback(() => {
        setIsContactSupportFormVisible(false);
    }, []);

    const handleShowEmailChangeRequestedPopup = useCallback(() => {
        setIsRequestedPopupVisible(true);
    }, []);

    const handleHideEmailChangeRequestedPopup = useCallback(() => {
        setIsContactSupportFormVisible(false);
        setIsRequestedPopupVisible(false);
    }, []);

    const handleCancelRequest = useCallback(() => {
        if (!ticketId) return;

        mutate({
            params: { path: { ticketId } },
        });
    }, [ticketId, mutate]);

    return {
        handleCancelRequest,
        progress: isLoading,
        isContactSupportFormVisible,
        isRequestedPopupVisible,
        handleShowContactSupportForm,
        handleHideContactSupportForm,
        handleShowEmailChangeRequestedPopup,
        handleHideEmailChangeRequestedPopup,
    };
};

export const useEmailChangeForm = () => {
    const [isEmailChangeFormVisible, setIsEmailChangeFormVisible] = useState(false);

    const handleShowEmailChangeForm = useCallback(() => {
        // TODO: Will be implemented in a separate task

        setIsEmailChangeFormVisible(true);
    }, []);

    return {
        isEmailChangeFormVisible,
        handleShowEmailChangeForm,
    };
};
